"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Delete = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Delete =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Delete, _React$Component);

  function Delete(_props, context) {
    var _this;

    _classCallCheck(this, Delete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Delete).call(this, _props, context));

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null,
      loading: false
    });

    _defineProperty(_assertThisInitialized(_this), "cache", void 0);

    _defineProperty(_assertThisInitialized(_this), "delete", function _callee(props) {
      var error, res;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              error = null;
              _context.prev = 1;
              _context.next = 4;
              return regeneratorRuntime.awrap(fetch(props.uri, {
                body: _this.props.body,
                method: 'DELETE',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              }));

            case 4:
              res = _context.sent;

              if (!(res.status >= 400 && res.status < 500)) {
                _context.next = 7;
                break;
              }

              throw new Error('Resource error');

            case 7:
              _this.cache.deleteItem(props.uri);

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              error = _context.t0;

            case 13:
              if (props.onError && error) {
                props.onError(error);
              } else if (!error && props.onSuccess) {
                props.onSuccess();
              }

              _this.setState(function (prevState) {
                return _objectSpread({}, prevState, {
                  error: error
                });
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, [[1, 10]]);
    });

    _this.cache = context.cache;
    return _this;
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread({
        onDelete: this.delete
      }, this.state));
    }
  }]);

  return Delete;
}(_react.default.Component);

exports.Delete = Delete;